/** Binary to and from base64, as adapter state holds a CDO. */

/** The bytes of a base64 string. */
export function base64ToBytes(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
}

/** Base64 of some bytes. */
export function bytesToBase64(bytes: ArrayLike<number>): string {
  let binary = "";
  for (let index = 0; index < bytes.length; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }
  return btoa(binary);
}
